import { Box, Heading } from '@99designs/emu';
import { Price } from '@99designs/marketing-ui';
import type { Price as PriceType } from '../../types';

type Props = {
    price: PriceType;
};

export function PackagePrice({ price }: Props) {
    return (
        <Box display="flex" justifyContent="space-between" paddingTop="0.75bu">
            {__('Total price')}
            <Heading appearanceLevel={4} accessibilityLevel={7}>
                <Price amount={price.amountInCents} currency={price.currency} />
            </Heading>
        </Box>
    );
}
